import Link from "gatsby-link";
import React from "react";

import NowPlaying from "./nowplaying";
import styles from "./header.module.css";

const Nav = () => (
  <nav>
    <ul>
      <li>
        <Link to="/" activeClassName={styles.active} exact>
          Home
        </Link>
      </li>
      <li>
        <Link to="/projects" activeClassName={styles.active} exact>
          Projects
        </Link>
      </li>
    </ul>
  </nav>
);

const Header = () => (
  <header className={styles.header}>
    <NowPlaying />
    <div className={styles.logo} />
    <Nav />
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js